import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { updateFilters, updateStream } from '@/mocks/home';

export default function UpdateStream() {
  const [active, setActive] = useState('全部');

  const rows = active === '全部' ? updateStream : updateStream.filter((row) => row.tag === active);

  return (
    <section id="updates" className="w-full border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <Reveal>
          <div className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
                <span className="h-px w-8 bg-primary-500" />
                实时更新
              </p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                今天的整理进度都在这里
              </h2>
            </div>

            <div className="flex flex-wrap gap-1 rounded-full border border-background-300 bg-background-50 p-1">
              {updateFilters.map((filter) => (
                <button
                  key={filter}
                  type="button"
                  onClick={() => setActive(filter)}
                  className={`whitespace-nowrap rounded-full px-3.5 py-1 text-xs font-medium transition-colors ${
                    active === filter
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-900'
                  }`}
                >
                  {filter}
                </button>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="hidden grid-cols-[80px_72px_1fr_100px] items-center gap-4 border-b border-background-200 bg-background-100/70 px-6 py-3 text-xs font-medium text-foreground-500 md:grid">
              <span>时间</span>
              <span>类型</span>
              <span>更新内容</span>
              <span className="text-right">来源</span>
            </div>

            <ul className="divide-y divide-background-100">
              {rows.map((row, i) => (
                <li
                  key={`${row.time}-${i}`}
                  className="grid grid-cols-1 gap-2 px-5 py-4 transition-colors hover:bg-background-100/60 md:grid-cols-[80px_72px_1fr_100px] md:items-center md:gap-4 md:px-6"
                >
                  <span className="font-mono text-xs text-foreground-500 md:text-sm">{row.time}</span>
                  <span className="w-fit rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-800">
                    {row.tag}
                  </span>
                  <span className="text-sm text-foreground-800">{row.text}</span>
                  <span className="flex items-center gap-1 text-xs text-foreground-500 md:justify-end">
                    <i className="ri-user-line text-sm md:hidden" />
                    {row.source}
                  </span>
                </li>
              ))}
            </ul>

            {rows.length === 0 && (
              <div className="px-6 py-12 text-center text-sm text-foreground-500">该分类下暂无更新</div>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}